module.exports = __webpack_public_path__ + "img/ModalKilat-Logo@3x.f9a36fad.png";